import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
const NoWrapLink = styled(UILink).withConfig({
  displayName: "CalculatorAnchorLink__NoWrapLink",
  componentId: "sc-14s1h33-0"
})(["white-space:nowrap;"]);

const CalculatorAnchorLink = () => {
  const handleClick = () => {
    const calculator = document.querySelector('#calculator');

    if (calculator) {
      calculator.scrollIntoView({
        behavior: 'smooth'
      });
    }

    getUsageTracker().track('scrollInteraction', {
      name: 'page-subtitle',
      action: 'clicked calculate your price'
    });
  };

  return /*#__PURE__*/_jsxs(NoWrapLink, {
    className: "m-left-2",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.calculateYourPrice"
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "next",
      size: "small",
      className: "m-left-1",
      style: {
        transform: 'rotate(90deg)',
        color: CALYPSO_DARK
      }
    })]
  });
};

export default CalculatorAnchorLink;